import React from 'react';
import Breadcrumbs from 'components/breadcrumbs'

function PageHeader(props) {
    return (
        <div>
            { props.breadcrumbs && <Breadcrumbs breadcrumbs={props.breadcrumbs} breadcrumbsCurrentPage={props.breadcrumbsCurrentPage} />}
            <div className="py-2">
                <div className="d-flex justify-content-between w-100 flex-wrap">
                    <div className="mb-3 mb-lg-0">
                        <h1 className="h3">{props.title}</h1>
                    </div>
                    <div className="d-flex">
                        {props.buttons}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PageHeader;
